import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const consultarPrecertificacionUrl = (request) =>
  `api/v1/websalud/primeraars/precertificaciones/${request.numeroPrecertificacion}`;

const confirmarPrecertificacionUrl = (request) =>
  `api/v1/websalud/primeraars/precertificaciones/${request.numeroPrecertificacion}/confirmacion?compania=${request.compania}`;

const cancelarPrecertificacionUrl = (request) =>
  `api/v1/websalud/primeraars/precertificaciones/${request.numeroPrecertificacion}/cancelacion?compania=${request.compania}`;

const precertificacionUrl = "api/v1/websalud/primeraars/precertificaciones";

const consultarPrecertificacion = (request) =>
  InterceptToken(
    BaseApi.get,
    consultarPrecertificacionUrl(request.requestData),
    { compania: request?.requestData?.compania },
    request.requestHeaders
  ).then((response) => response.data);

const confirmarPrecertificacion = (request) =>
  InterceptToken(
    BaseApi.post,
    confirmarPrecertificacionUrl(request.requestData),
    { compania: request?.requestData?.compania },
    request.requestHeaders
  ).then((response) => response.data);

const cancelarPrecertificacion = (request) =>
  InterceptToken(
    BaseApi.post,
    cancelarPrecertificacionUrl(request.requestData),
    { compania: request?.requestData?.compania },
    request.requestHeaders
  ).then((response) => response.data);

const tiposSolicitudesPrecertificacion = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    `${precertificacionUrl}/solicitudes/tipos`,
    request
  );
  return response.data;
};

const crearPrecertificacion = async (request) => {
  const response = await InterceptToken(
    BaseApi.post,
    precertificacionUrl,
    request
  );
  return response.data;
};

const buscarPrecertificacion = async (request) => {
  const url = `${precertificacionUrl}/${request.tipoPss}/${request?.codigoPss}/buscar`;
  const response = await InterceptToken(BaseApi.get, url, request);
  return response.data;
};

const buscarUnaPrecertificacion = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    `${precertificacionUrl}/${request.id}/detalle`
  );
  return response.data;
};

const descargarAdjuntoPrecertificacion = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    `${precertificacionUrl}/${request.id}/${request.nombreArchivo}/descargar/adjunto`,
    null,
    { responseType: "blob" }
  );

  return response?.data;
};

const descargarVoucherPrecertificacion = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    `${precertificacionUrl}/${request.numeroSolicitud}/voucher/descargar`,
    null,
    { responseType: "blob" }
  );

  return response;
};

const modificarPrecertificacion = async (id, request) => {
  const response = await InterceptToken(
    BaseApi.put,
    `${precertificacionUrl}/${id}`,
    request
  );
  return response.data;
};

const exportedObject = {
  consultarPrecertificacion,
  confirmarPrecertificacion,
  cancelarPrecertificacion,
  tiposSolicitudesPrecertificacion,
  crearPrecertificacion,
  buscarPrecertificacion,
  buscarUnaPrecertificacion,
  descargarAdjuntoPrecertificacion,
  descargarVoucherPrecertificacion,
  modificarPrecertificacion
};

export default exportedObject;
